import { render } from "./LeadSource.vue?vue&type=template&id=bae23ed8&scoped=true"
import script from "./LeadSource.vue?vue&type=script&lang=js"
export * from "./LeadSource.vue?vue&type=script&lang=js"

import "./LeadSource.vue?vue&type=style&index=0&id=bae23ed8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae23ed8"]])

export default __exports__